import {
  Component,
  Prop,
  h,
  State,
  Event,
  type EventEmitter,
  Element,
} from '@stencil/core';
import spinner from '@se/icons/svg/spinner.svg';
import { getProcutDetails } from './uiaas-search-product-dropdown-button-actions';
import type { INodeExtended } from './productDetails.types';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';


@Component({
  tag: 'uiaas-search-product-dropdown-button',
  shadow: true,
  styleUrl: 'uiaas-search-product-dropdown-button.scss',
})
export class ProductDropdownButton {
  get ajaxIsLoading(): boolean {
      return this._ajaxIsLoading;
  }

  set ajaxIsLoading(value: boolean) {
      this._ajaxIsLoading = value;
  }
    @Prop() readonly country: string;
    @Prop() readonly language: string;
    @Prop() readonly brand: string;
    @Prop() readonly isDropdownVisible: boolean;
    @Prop() readonly toggleDropdown: CallableFunction;
    @Prop() readonly documentsTerm: string = '';
    @Prop() readonly rangesTerm: string = '';
    @Prop({ mutable: true }) labelProvider?: labelProviderInterface; //eslint-disable-line @stencil-community/strict-mutable
    @Prop() readonly gridView: boolean;
    @Prop() readonly dashboardView: boolean = false;
    @Prop() readonly isRtl: boolean = false;

    @State() private _ajaxIsLoading = false;

    @Element() el: HTMLElement;

    @Event({
      eventName: 'productsCardDetails',
      composed: true,
      cancelable: true,
      bubbles: true,
    })
      eventEmitterProductsCards: EventEmitter;

    private closestSearchTabElement: INodeExtended['host'];
    private token: string;
    private apigeeAuth: string;
    private apiKey: string;
    private endpoint: string;

    private getElementParentObject(el: HTMLElement): {
        tagName: string;
        parentHost: INodeExtended['host'];
    } {
        const parent = el?.getRootNode();
        const parentHost = (parent as INodeExtended)?.host;

        return {
          tagName: (
                parentHost as INodeExtended['host']
          )?.tagName.toLowerCase(),
          parentHost,
        };
    }

    private getClosestElement(el: HTMLElement, targetName, finalElement) {
        const { tagName, parentHost } = this.getElementParentObject(el);

        switch (tagName) {
        case undefined:
          return;
        case targetName:
          this.closestSearchTabElement = parentHost;
          return;
        case finalElement:
          return;
        default:
          this.getClosestElement(parentHost as HTMLElement, targetName, finalElement);
        }
    }

    connectedCallback() {
        if(this.dashboardView){
          this.getClosestElement(this.el, 'dashboard-tab-view-v2', 'uiaas-search');
        } else {
          this.getClosestElement(this.el, 'uiaas-search-tab', 'uiaas-search');
        }

        const closestElement = this.closestSearchTabElement as HTMLElement;

        this.token = closestElement?.getAttribute('apigee-token-url');
        this.apigeeAuth = closestElement?.getAttribute('apigee-auth');
        this.apiKey = closestElement?.getAttribute('api-key');
        this.endpoint = closestElement?.getAttribute('api-endpoint');
    }

    private getAndSetDocumentsData = async (e: MouseEvent) => {
        e.preventDefault();
        this._ajaxIsLoading = true;

        const documentsData = await getProcutDetails(
          this.apiKey,
          this.token,
          this.apigeeAuth,
          this.endpoint,
          this.brand,
          this.country,
          this.language,
          this.documentsTerm,
          this.rangesTerm,
          this.toggleDropdown
        );

        setTimeout(() => {
            this._ajaxIsLoading = false;
        }, 500);

        this.eventEmitterProductsCards.emit(documentsData);
    };

    render() {
        return (
          <section
            class={{
              'product-card-dropdown-button': true,
              'product-card-dropdown-button--grid': this.gridView,
            }}
            dir={this.isRtl ? 'rtl' : 'auto'}>
            <qds-button
              action="dropdown-close"
              class={{'product-card-dropdown-button__qds-button':true,
                      'product-card-dropdown-button__qds-button--loading': this.ajaxIsLoading}}
              data-card-area="dropdown-cta"
              tabindex={this.isDropdownVisible ? '-1' : '0'}
              onClick={async (e) => {
                  // @ts-ignore
                  await this.getAndSetDocumentsData(e);
              }}
              text={this.labelProvider('products.dropdown.documents-and-ranges', 'Documents & Ranges')}
            >
            </qds-button>
            <div
              class={{'loading-icon': true,
                      'product-card-dropdown-button__spinner': true,
                      'product-card-dropdown-button__spinner--loading': this.ajaxIsLoading}}
              innerHTML={spinner}
            >
            </div>
          </section>
        );
    }
}
